jQuery(document).ready(function() {
  let form = jQuery('.gform_wrapper, .hero--homepage__form');
  if (form.length) {
    let fields = form.find('.gfield, .field');
    fields.each(function() {
      let field = jQuery(this);
      let input = field.find('input, textarea, select');
      let label = field.find('label');

      if(input.val()) {
        label.addClass('small');
      }

      input.on('focus', function() {
        label.addClass('small');
      });

      input.on('blur', function() {
        if(!input.val()) {
          label.removeClass('small');
        }
      });
    });
  }
});
